import React, { useEffect, useState } from 'react';
import { Dropdown, useFilterContext, useListContextRequired } from 'ui-builder';
import { SubscriptionEvent, WebhookSubscription, WebhookSubscriptionsFilter } from 'nekst-api';
import { useSubscriptionEventHelper } from './subscriptionEventHelper';

export default function SubscriptionTypeFilter() {
  const filterContext = useFilterContext<WebhookSubscriptionsFilter>();
  const { data } = useListContextRequired<WebhookSubscription>();

  const [usedEvents, setUsedEvents] = useState<Record<SubscriptionEvent, true>>({} as Record<SubscriptionEvent, true>);

  const typeHelper = useSubscriptionEventHelper();

  useEffect(() => {
    data.forEach((item) => {
      setUsedEvents((prev) => ({
        ...prev,
        [item.eventType]: true
      }));
    });
  }, [data.length]);

  const keys = Object.keys(usedEvents);

  if (keys.length > 1) {
    return (
      <Dropdown
        options={keys.map((item) => ({
          label: typeHelper.getLabel(item as SubscriptionEvent),
          value: item
        }))}
        onChangeCallback={(newValue) => {
          filterContext.setFilterValue({
            event: newValue.event,
          })
        }}
        value={filterContext.filterValue?.event}
        source="event"
        hideLabel
        placeholder="Choose Event Type"
      />
    );
  } else {
    return null;
  }
}
